// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3J89C","options":"AnswerScale_options__1X34P","selected":"AnswerScale_selected__1igj0"};